import { AnimatePresence, motion, useReducedMotion } from "motion/react";

export function ViewTransition({ transitionKey, children }) {
  const reduced = useReducedMotion();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={transitionKey}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: reduced ? 0 : 0.12, ease: "linear" }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
